import { SearchInput, SearchInputProps } from "@/components/search-input/search-input";
import { Button, ButtonColorVariant, ButtonSize, ButtonVariant } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { SearchIcon } from "lucide-react";
import { useState } from "react";

interface ResponsiveSearchProps extends Omit<SearchInputProps, "size" | "className" | "variant"> {}

export function ResponsiveSearch({
  placeholder = "Search...",
  value,
  onSearchChange,
  onChange,
  onClear,
  ...searchInputProps
}: ResponsiveSearchProps) {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  return (
    <>
      <div className="xs:flex hidden grow">
        <SearchInput
          placeholder={placeholder}
          value={value}
          onSearchChange={onSearchChange}
          onChange={onChange}
          onClear={onClear}
          size="md"
          className="h-9 grow"
          {...searchInputProps}
        />
      </div>

      <div className="xs:hidden flex">
        <Popover open={isPopoverOpen} onOpenChange={setIsPopoverOpen}>
          <PopoverTrigger asChild>
            <Button
              variant={value ? ButtonVariant.Filled : ButtonVariant.Outlined}
              colorVariant={value ? ButtonColorVariant.Primary : ButtonColorVariant.Secondary}
              size={ButtonSize.Icon}
              aria-label="Search"
            >
              <SearchIcon className="h-4 w-4" />
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-80 p-3" align="end">
            <SearchInput
              placeholder={placeholder}
              value={value}
              onSearchChange={(val) => {
                onSearchChange?.(val);
                if (!val) {
                  setIsPopoverOpen(false);
                }
              }}
              onChange={onChange}
              onClear={() => {
                onClear?.();
                setIsPopoverOpen(false);
              }}
              size="md"
              className="h-9"
              autoFocus
              {...searchInputProps}
            />
          </PopoverContent>
        </Popover>
      </div>
    </>
  );
}
